<template>
  <div class="started-match-popup">
    <ScaleTransition appear>
      <MatchRoomButton
        v-if="isStartedMatchActive"
        small
        @clicked="navigate"
        :match="startedMatch"
        class="started-match-popup__label"
      />
      <NearesTourButton
        v-else-if="isNearTournamentActive"
        small
        close-delay="3000"
        @clicked="navigate"
        @onTick="time = Date.now()"
        @isDeactivated="closeNearesTourButton"
        :tournament="nearTournament"
        class="started-match-popup__label"
      />
    </ScaleTransition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ScaleTransition } from "@/components/common/transitions";
import MatchRoomButton from "@/components/tournament/MatchRoomButton";
import NearesTourButton from "@/components/tournament/NearesTourButton";
import tournamentsService from "@/services/tournaments";

import {
  checkIsNotEnded,
  checkIsNotStarted
} from "@/components/tournament/types";

export default {
  components: { ScaleTransition, MatchRoomButton, NearesTourButton },

  data() {
    return {
      loading: false,
      time: Date.now(),
      isStartedMatchActive: false,
      isNearTournamentActive: false,

      tournaments: []
    };
  },

  sockets: {
    notification(message) {
      const isAllowed = ["matches_performed", "tournament_changed"].includes(
        message.type
      );
      if (isAllowed) {
        this.fetchTournamentsData();
      }
    }
  },

  computed: {
    ...mapGetters(["routeParams"]),

    ...mapGetters("tournaments", ["participation", "startedMatch"]),

    hasStartedMatch() {
      if (!this.startedMatch) return false;
      const currentMatchID = this.routeParams.match_id || 0;
      let { id } = this.startedMatch;

      return id && currentMatchID !== id;
    },

    hasNearTournament() {
      if (!this.nearTournament) return false;
      const currentTourID = this.routeParams.tournament_id || 0;
      let { id, status, starts_at } = this.nearTournament;

      return (
        id &&
        currentTourID !== id &&
        checkIsNotStarted(status) &&
        this.$dayjs(this.time).isBefore(this.$dayjs.unix(starts_at))
      );
    },

    nearTournament() {
      return this.tournaments
        .filter(
          o => checkIsNotEnded(o.status) && this.participation.includes(o.id)
        )
        .shift();
    }
  },

  watch: {
    hasStartedMatch: {
      handler: function(after) {
        this.isStartedMatchActive = after;
      },
      immediate: true
    },

    hasNearTournament: {
      handler: function(after) {
        this.isNearTournamentActive = after;
      },
      immediate: true
    },
    participation: "fetchTournamentsData"
  },

  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },

  methods: {
    async fetchTournamentsData() {
      if (this.loading) return false;
      this.loading = true;

      const list = await tournamentsService.fetchTournaments();
      list.sort((a, b) => a.starts_at - b.starts_at);

      this.tournaments = list;
      this.loading - false;
    },

    navigate(href) {
      this.$router.push(href);
    },

    closeNearesTourButton() {
      this.isNearTournamentActive = false;
    }
  }
};
</script>

<style lang="scss">
.started-match-popup {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 12;
  pointer-events: none;
  transition: 0.2s;

  .modal-open & {
    opacity: 0;
  }

  &__label {
    position: absolute;
    bottom: 30px;
    right: 30px;
    pointer-events: auto;
  }
}
</style>
